import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ResponseHelper } from 'src/app/manager/response.helper';
import { NotificationService } from 'src/app/service/notification.service';
import { Token } from 'src/app/manager/token';
import { finalize } from 'rxjs/operators';
import { ClientInstructionService } from 'src/app/service/client-instruction.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { dropDownFields } from 'src/app/manager/dropdown-feilds';
import { ExcelService } from 'src/app/service/client-configuration/excel.service';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-client-instruction',
  templateUrl: './client-instruction.component.html',
  styleUrls: ['./client-instruction.component.scss'],
  providers: [dropDownFields]
})
export class ClientInstructionComponent implements OnInit {
  Title = "Client Instruction";
  RowSelection = "single";
  ResponseHelper: ResponseHelper;
  UserId;
  ClientId;
  DisableClientList = true;
  DisableAll = false;
  saveDisable = false;
  ShowRoleError = false;
  ClientList: any[] = [];
  PayerList: any[] = [];
  PracticeList: any[] = [];
  ProviderList: any[] = [];
  InstructionId = 0;
  GridApi;
  RoleMessage;
  GridColumnApi;
  InstructionForm: FormGroup;
  InstructionModel = new InstructionModel();
  Validated = false;
  viewCountData: boolean = false;
  selec;
  flag: boolean = true
  singleclient: boolean = false
  paydata = 0;
  pracdata = 0
  prodata = 0
  showCount: boolean = true
  showGebbsAction: boolean = true
  readCountData = [];
  canEdit: boolean = true;
  ColumnDefs = []
  RowData = [];
  Role;
  DisplayFileError = false;
  Filename = "No File chosen";
  File = null;
  FileBase64;
  DisableFileInput = false;
  DisableUpload: boolean = false;
  disableDownload: boolean = false;
  selectedRecord: boolean = false;
  truefile: boolean = false;
  defaultColDef:any
  addFieldSetting = {
    idField: 'Client_Id',
    textField: 'Client_Name'
  }
  //client-instruction new changes 21-06-2021

  CommunicationChannelList: any[] = [];
  SourceList: any[] = [];
  UpdateCategoryList: any[] = [];

  viewInstructionBox = false;
  FileFormname = "No File chosen";

  disabledInstruction = false;
  fileSizeExceeds = false;
  sendClientID = [];
  EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  EXCEL_EXTENSION = '.xlsx';
  Pdf_type = 'application/pdf';
  Pdf_Extension = '.pdf';
  word_type = 'text/csv';
  word_Extension = '.doc';
  Text_type = 'application/txt';
  Text_Extension = '.txt';
  Image_type = 'application/image/jpeg';
  Image_Extension = '.jpg';
  Email_Type = 'application/octet-stream';
  Email_Extension = '.jpg';
  FileBase64Form;
  sendToCountModel;
  storeColDef : any;
  @ViewChild('fileAttachement') fileAttachement: ElementRef;

  constructor(private selectedFields: dropDownFields,
    private router: Router,
    private excelService: ExcelService,
    private fb: FormBuilder,
    private notificationservice: NotificationService,
    private instructionservice: ClientInstructionService) {
    var token = new Token(this.router);
    var userdata = token.GetUserData();
    this.UserId = userdata.UserId;
    this.Role = userdata.Role;
    switch (this.Role) {
      case "Client Supervisor":
        this.showGebbsAction = false
        break;
      case "Supervisor":
        this.showCount = false;
        break;
    }

     this.ColumnDefs = [
      { field: "Id", hide: true, rowGroupIndex: null },
      { field: "Client_Id", hide: true, rowGroupIndex: null },
      { headerName: "Source", field: "Source", width: 100, },
      { headerName: "Communication Channel", field: "Communication_Channel" },
      { headerName: "Update Category", field: "Update_Category" },
      { headerName: "Received From", field: "Received_From" },
      {
        headerName: "Payer Name", field: "Payer_Name", cellClass: "cell-wrap-text",
        autoHeight: true
        , cellStyle: { 'white-space': 'normal' }
      },
      { headerName: "Practice Name", field: "Practice_Name" },
      { headerName: "Provider Name", field: "Provider_Name" },
      { headerName: "CPT Code", field: "CPT_Code" },
      { headerName: "Revenue Code", field: "Revenue_Code" },
      { headerName: "Diagnosis Code", field: "Diagnosis_Code" },
      { headerName: "Modifier", field: "Modifier" },
      { headerName: "Place of Service", field: "Place_of_Service" },
      { headerName: "Instructions - Scenario", field: "Instructions_Scenario",width: 200, cellRenderer: this.ActionCellRendererClass, cellStyle: { cursor: 'pointer' } },
      { headerName: "Instructions - Action", field: "Instructions_Action",width: 170, cellRenderer: this.ActionCellRendererClass, cellStyle: { cursor: 'pointer' } },
      // {
      //   headerName: "Instructions", field: "Instructions", cellClass: "cell-wrap-text",
      //   autoHeight: true, cellStyle: { 'white-space': 'normal' }
      // },
      {
        headerName: "Created By",
        field: "Created"
      },
      {
        headerName: "Created Date & Time",
        field: "Created_Date",
        cellRenderer: this.datecheck
      },
      {
        headerName: "Last Modified By",
        field: "Updated_By"
      },
      // { headerName: "Modified Date & Time",hide: true, field: 'Updated_Date', cellRenderer: this.datecheck },
      { headerName: "Modified Date & Time", field: 'Updated_By_Date', cellRenderer: this.datecheck },
      { headerName: "Status", field: "Type" },
      { headerName: "Acknowledgement Status", field: "Read_By_Agent_Count", width: 200, cellRenderer: this.ActionCellRendererClass, cellStyle: { cursor: 'pointer' } },
      { headerName: "Update Attachment", field: "Read_By_Agent_Count", width: 170, cellRenderer: this.ActionCellRendererClass, cellStyle: { cursor: 'pointer' } },
      // { headerName: "GeBBS Action", field: "Read_By", hide: this.showGebbsAction, cellRenderer: this.Action, }
      //,
      // {
      //   headerName: "Action", cellRenderer: this.showOrderCellRenderer
      // }
    ];
  }

  ngOnInit() {
    this.defaultColDef = {
      cellRenderer: showOrderCellRenderer,
      // width: 80
    };
    function showOrderCellRenderer(params) {
      var eGui: any = document.createElement("div");
      // console.log('params : ', params)

      eGui.innerHTML = `<span title="${params.value}">${params.value}</span>`;
      // var start = new Date();
      // while (new Date() - start < 15) { }
      return eGui;
    }
    this.ResponseHelper = new ResponseHelper(this.notificationservice);
    var token = new Token(this.router);
    var userdata = token.GetUserData();
    this.UserId = userdata.UserId;
    console.log('userdata : ', userdata)
    this.ClientId = userdata.Clients[0].Client_Id;
    this.InstructionForm = this.CreateForm();
    // this.GetClientList()
    this.ClientList = this.selectedFields.setSelected(userdata.Clients)
    this.selectedValue(this.ClientList, 'ClientList')

  }

  datecheck(params) {

    let val
    val = params.value ? moment(params.value).format('MM/DD/YYYY HH:mm:ss') : '';
    return val;
  }





  selectedValue(data, name) {
    if (data.length == 1 && data.length) {
      switch (name) {
        case 'PracticeList':
          this.InstructionModel.Practice_Name = data[0].Value;
          break;
        case 'ProviderList':
          this.InstructionModel.Provider_Name = data[0].Value
          break;
        case 'PayerList':
          this.InstructionModel.Payer_Name = data[0].Value
          break;
        case 'ClientList':
          this.ClientId = data[0].Client_Id
          this.InstructionModel.Client_Id = data[0].Client_Id;
          this.GetAllLookups();
          this.GetClientInstructions();
          break;

      }
      this.singleclient = true
    } else {

    }

  }

  CreateForm() {
    return this.fb.group({
      'Client': ['', Validators.required],
      'Payer': ['', Validators.required],
      'Provider': ['', Validators.required],
      'Practice': ['', Validators.required],
      // 'Instruction': ['', Validators.required],
      'Instructions_Scenario' : ['', Validators.required],
      'Instructions_Action' : ['', Validators.required],
      'Source': ['', Validators.required],
      'CommunicationChannel': ['', Validators.required],
      'UpdateCategory': ['', Validators.required],
      'IsActive': [false, Validators.required],
      'IsCPTCode': [''],
      'IsRevenueCode': [''],
      'IsDiagnosisCode': [''],
      'IsModifierCode': [''],
      'IsPlaceOfServiceCode': [''],
      'Received_From': ['', Validators.required]
    })
  }

  OnGridReady(event) {
    //event.api.sizeColumnsToFit()
    //event.api.sizeColumnsToFit()
    this.GridApi = event.api;
    this.GridColumnApi = event.columnApi;
    setTimeout(function () {
      event.api.resetRowHeights();
    }, 500);
  }

  onColumnResized(event) {
    if (event.finished) {
      this.GridApi.resetRowHeights();
    }
  }

  OnRowClicked(event) {
    this.selectedRecord = true
    this.ShowRoleError = false;
    this.fileSizeExceeds = false;
    this.InstructionId = event.data.Id;
    this.sendToCountModel = event.data
    console.log('onowClicked : ', event.data)
    this.GetSingleClientInsurance(event.data);
  }
  onCellClicked(data) {

    switch (data.colDef.headerName) {
      case "Acknowledgement Status": {
        this.instructionservice.getCountData(this.ClientId, data.data.Id).pipe(finalize(() => {
          this.viewCountData = true
        })).subscribe(res => {
          this.ResponseHelper.GetSuccessResponse(res)
          data = res
          this.readCountData = res
          //  this.ClientUpdateData = data.Data
        }, err => {
          this.ResponseHelper.GetFaliureResponse(err);
        })
        this.storeColDef = null;
        break;
      }
      case "Instructions - Scenario": {
        // this.viewInstructionBox = true;
        // this.disabledInstruction = true;
        this.storeColDef = data.colDef;
        break;
      }
      case "Instructions - Action": {
        // this.viewInstructionBox = true;
        // this.disabledInstruction = true;
        this.storeColDef = data.colDef;

        break;
      }
      case "Update Attachment": {
      let dataobj = { Reference_File_Name: data.data.Reference_File_Name, Display_File_Name: data.data.Display_File_Name };

        this.instructionservice.downloadAttachedFile(dataobj).subscribe(res => {
          let abc = res.data;
          this.savewithextension(abc, data.data.Display_File_Name, data.data.File_Format.toLowerCase());

          // this.ResponseHelper.GetSuccessResponse(res);
        }, err => {
          let data = [{ Message: "No Attachment Found.", Type: "ERROR" }]
          this.notificationservice.ChangeNotification(data)

          // this.ResponseHelper.GetFaliureResponse(data[0])
        })
        this.storeColDef = null;

        break;
      }
      default:
        this.storeColDef = null;

        break;
    }
  }

  exportToExcel() {
    let dataobj = { Client_Id: this.ClientId };
    this.instructionservice.exportToExcel(dataobj).subscribe((res)=> {
      this.excelService.downloadExcel(res);
    },
    err =>{
      this.ResponseHelper.GetFaliureResponse(err);
    });
  }

  ToggleModal(e) {
    this.viewCountData = false
  }
  AutoSizeGrid(event) {
    event.columnApi.autoSizeColumns(["Practice_Name", "Provider_Name", "Type", "GeBBS_Action"]);
  }



  ClientListOnChange(event) {

    this.ClearData();
    this.ShowRoleError = false;
    this.InstructionModel = new InstructionModel();
    if (!event.Client_Id || event.Client_Id == "0") {
      // this.DisableSearch = true;
    }
    else {
      this.ClientId = event.Client_Id;
      this.InstructionModel.Client_Id = this.ClientId;

      this.InstructionForm.patchValue({ "Client": this.ClientId });
      this.GetAllLookups();
      this.GetClientInstructions();
    }
  }

  GetAllLookups() {


    this.instructionservice.GetAllLookups(this.ClientId).pipe(finalize(() => {

    })).subscribe(
      res => {
console.log(res.Data, 'json data get all lookups');

        this.PayerList = this.selectedFields.setSelected(res.Data.Payer);
        this.PracticeList = this.selectedFields.setSelected(res.Data.Practice);
        this.ProviderList = this.selectedFields.setSelected(res.Data.Provider);
        this.SourceList = this.selectedFields.setSelected(res.Data.Source);
        this.CommunicationChannelList = this.selectedFields.setSelected(res.Data.Communication_Channel);
        this.UpdateCategoryList = this.selectedFields.setSelected(res.Data.Update_Category);
        this.selectedValue(this.PayerList, 'PayerList');
        this.selectedValue(this.PracticeList, 'PracticeList');
        this.selectedValue(this.ProviderList, 'ProviderList');
        this.selectedValue(this.SourceList, 'SourceList');
        this.selectedValue(this.CommunicationChannelList, 'CommunicationChannelList');
        this.selectedValue(this.UpdateCategoryList, 'UpdateCategoryList');
      },
      err => {
        this.ResponseHelper.GetFaliureResponse(err);
      }
    );
  }

  GetClientInstructions() {
    this.instructionservice.GetClientInstructions(this.ClientId).pipe(finalize(() => {
    })).subscribe(
      res => {
        let arr = []
        res.Data.forEach((e) => {
          if (e.Updated_By == "") {
            // e.Updated_Date = "";
            e.Updated_By_Date = "";
            arr.push(e);
          } else {
            e.Updated_By_Date = e.Updated_Date;
            arr.push(e);
          }
        });
        this.RowData = arr;
      },
      err => {
        this.RowData = [];
        this.ResponseHelper.GetFaliureResponse(err);
      }
    );
  }

  GetSingleClientInsurance(data) {
    this.ManageForEdit(data);
    this.ManageInstruction(data);
    this.instructionservice.GetSingleClientInstruction(this.ClientId, this.InstructionId).pipe(finalize(() => {
    })).subscribe(
      res => {
        console.log('GetSingleClientInsurance() : ', res.Data)
        // this.ManageForEdit(res.Data);
        //this.InstructionModel = res.Data;
        if(this.storeColDef) {
        if(this.storeColDef.headerName == 'Instructions - Scenario' ||
           this.storeColDef.headerName == 'Instructions - Action'){
          this.viewInstructionBox = true;
          this.disabledInstruction = true;
        }
      }
        this.sendClientID = [res.Data, this.InstructionForm, 'update' ,this.ClientId];
        this.ClearFileFormData();

        this.FileFormname = data.Display_File_Name ? data.Display_File_Name : 'No File Attached';
      },
      err => {

        this.InstructionModel = new InstructionModel();
        this.ResponseHelper.GetFaliureResponse(err);
      }
    );
  }

  ManageForEdit(ins) {
    // Client Logins - Client Instruction Module IAR-141

    if (this.Role == "Client Supervisor") {
      // this.Role == "Client Supervisor" && ins.Is_Client_Created == true
      this.canEdit = true;

    } else if (this.Role == "Supervisor") {
      // this.Role == "Supervisor" && ins.Is_Client_Created == false
      this.canEdit = true
    } else {
      this.canEdit = false;
    }


    // if (this.Role == "Client Supervisor" && ins.Created_By == this.UserId) {
    //   this.ShowRoleError = true;
    //   // this.RoleMessage = "Can be edited by Supervisor Only";
    //   this.InstructionModel = new InstructionModel();
    //   this.InstructionModel.Client_Id = this.ClientId;
    //   this.GridApi.deselectAll();
    // }
    // else
    if (this.Role == "QC" && this.UserId != ins.Created_By) {
      this.ShowRoleError = true;
      this.RoleMessage = "Your role can edit only self created instructions";
      this.InstructionModel = new InstructionModel();
      this.InstructionModel.Client_Id = this.ClientId;
      this.GridApi.deselectAll();
    }
    // Client Logins - Client Instruction Module IAR-141
    // else if (this.Role == "Client Supervisor" && ins.Is_Client_Created) {

    // }
    else {
      this.ShowRoleError = false;
      this.InstructionModel = ins;
    }
  }
  showOrderCellRenderer(params) {
    var cell: any = document.createElement("div");
    console.log('params : ', params)

    cell.innerHTML = `<button type="button" class="btn blue square-btn blue-hover btn-txt ">Export to excel</button>`;
    // var start = new Date();
    // while (new Date() - start < 15) { }
    return cell;
  }
  callMe(params) {
    console.log('callMe(params) : ', params);
  }
  FormSubmit() {

    this.Validated = true;

    if (this.InstructionForm.valid) {
      if (this.InstructionModel.Id == 0) {
        //post

        this.InsertInstruction();
      }
      else {

        this.UpdateInstruction();
        //put
      }
    }
  }

  InsertInstruction() {
    this.DisableAll = true;
    this.saveDisable = true;
    this.instructionservice.InsertInstruction(this.InstructionModel).pipe(finalize(() => {
      this.DisableAll = false;
      this.saveDisable = false
    })).subscribe(
      res => {
        this.GetClientInstructions();
        this.ResponseHelper.GetSuccessResponse(res);
        this.InstructionModel = new InstructionModel();
        this.InstructionModel.Client_Id = this.ClientId;
        this.InstructionId = 0;
        this.Validated = false;
        this.ClearFileFormData()
      },
      err => {
        if(err.status == 400){
          if(err.ModelState){
            this.notificationservice.ChangeNotification(
              [{ Message: err.ModelState["info.File"].toString(), Type: "ERROR" }]);
          } else {
            this.ResponseHelper.GetFaliureResponse(err);
          }
        } else{
          this.ResponseHelper.GetFaliureResponse(err);
        }
      });
  }

  UpdateInstruction() {
    this.DisableAll = true
    this.saveDisable = true

    this.instructionservice.UpdateInstruction(this.InstructionModel).pipe(finalize(() => {
      this.DisableAll = false;
      this.saveDisable = false
    })).subscribe(
      res => {

        this.GetClientInstructions();
        this.ResponseHelper.GetSuccessResponse(res);
        this.InstructionModel = new InstructionModel();
        this.InstructionModel.Client_Id = this.ClientId;
        this.InstructionId = 0;
        this.Validated = false;
        this.ClearFileFormData();
      },
      err => {
      if(err.status == 400){
        if(err.ModelState){
          this.notificationservice.ChangeNotification(
            [{ Message: err.ModelState["info.File"].toString(), Type: "ERROR" }]);
        } else {
          this.ResponseHelper.GetFaliureResponse(err);
        }
        } else{
          this.ResponseHelper.GetFaliureResponse(err);
        }
      }
    );
  }

  ClearData() {
    this.DisableAll = false;
    this.canEdit = true
    this.saveDisable = false
    this.selectedRecord = false;
    this.InstructionId = 0;
    this.DisableAll = false
    //  this.PayerList = [];
    //  this.PracticeList = [];
    //  this.ProviderList = [];
    this.InstructionModel = new InstructionModel();
    if (this.singleclient) {
      this.InstructionModel.Client_Id = this.ClientId;
    } else {
      this.InstructionModel.Client_Id = "0"
    }
    // this.ClearFileData()
    // this.RowData = [];
    this.Validated = false;

    //client-instruction new changes 23-06-2021
    const content = {'Instructions_Scenario': '', 'Instructions_Action': ''}
    this.InstructionForm.patchValue(content);
    this.fileSizeExceeds = false;
    this.FileFormname = "No File Chosen";
    this.sendClientID = [];
    this.fileSizeExceeds = false;

  }
  ActionCellRendererClass(params) {
    let val
    let eDiv = document.createElement('div');
    // if (!params.value) {
    val = params.value
    eDiv.innerHTML = '<a class="instructionAnchor">' + 'Click Here' + '</a>';
    // }
    return eDiv;
  }

  Action(params) {
    let val
    if (params.value == 0) {
      val = "No Action Taken"
    } else if (params.value == 1) {
      val = "Review Accepted"
    }
    return val;
  }
  GetFileData(event) {

    // let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      this.truefile = true
      this.File = event.target.files[0];
      this.Filename = this.File.name;
      this.ConvertToBase64()
    }
    else {
      this.truefile = false
      this.ClearFileData();
    }
  }

  ConvertToBase64() {
    let reader = new FileReader();
    reader.readAsDataURL(this.File);
    reader.onload = () => {
      this.FileBase64 = reader.result.toString().split(',')[1];
    }
  }

  ClearFileData() {
    this.File = null
    this.Filename = "No File Chosen";
    this.FileBase64 = null;
  }
  FileUpload() {
    if (this.File != null) {
      console.log('this.FileBase64 : ', this.FileBase64);
      this.DisplayFileError = false;
      this.DisableUpload = true;
      this.DisableFileInput = true;
      let dataobj = { File: this.FileBase64, File_Name: this.Filename, Client_Id: this.ClientId, User_ID:this.UserId };
      this.instructionservice.InstructionUpload(dataobj).pipe(finalize(() => {
        this.DisableUpload = false;
        this.Filename = null;
        this.File = null;
        if (this.ClientList.length == 1) {
          this.disableDownload = false
        } else {
          this.disableDownload = true
        }
        this.DisableFileInput = false;
        this.ClearFileData();
        if (!this.singleclient) {
          this.ClientId = "";
        }
        // this.Is_Special_Queue = false;
      })).subscribe(
        res => {
          this.truefile = false
          this.ResponseHelper.GetSuccessResponse(res)
        },
        err => {
          console.log(err);

          this.truefile = false
          this.notificationservice.ChangeNotification(err.Message[0]);
        }
      );
    }
    else {
      this.DisplayFileError = true;
    }
  }

  downloadTemplate() {
    this.instructionservice.downLoadTemplate().subscribe(res => {
      this.excelService.downloadExcel(res);
    }, err => {
      this.ResponseHelper.GetFaliureResponse(err);
    })
  }
    //client-instruction new changes
    ToggleInstructionModal(e){
      this.InstructionModel.Instructions_Scenario = e.Instructions_Scenario;
      this.InstructionModel.Instructions_Action = e.Instructions_Action;
      this.InstructionForm.patchValue(e)
      this.InstructionForm.value.instruction_update = e.instruction_update
      this.viewInstructionBox = false;
    }

    GetFileFormData(event) {

      // let reader = new FileReader();
      const fileSize = event.target.files[0].size / 1024 / 1024; // in MiB
      if (event.target.files && event.target.files.length > 0) {
        this.fileSizeExceeds = false;
        this.File = event.target.files[0];
        this.FileFormname = this.File.name;
        // this.InstructionModel.File = this.FileBase64;
        // this.InstructionForm.patchValue(this.InstructionModel.File);
        this.InstructionModel.File_Name = this.FileFormname;
        this.InstructionForm.patchValue(this.InstructionModel.File_Name);
        this.ConvertToBase64Form()

      }
      else {
        // alert('File size exceeds 5 MiB');
        this.fileSizeExceeds = true;
        this.InstructionModel.File_Name = "";
        this.ClearFileFormData();
      }
    }

    ConvertToBase64Form() {
      let reader = new FileReader();
      reader.readAsDataURL(this.File);
      reader.onload = () => {
        this.FileBase64Form = reader.result.toString().split(',')[1];
        this.InstructionModel.File = this.FileBase64Form;
        this.InstructionForm.patchValue(this.InstructionModel.File);
      }
    }

    ClearFileFormData() {
      this.File = null
      this.FileFormname = "No File Chosen";
      this.FileBase64Form = null;
    }

    openInstructionPopup(){
      this.viewInstructionBox = true;
      this.disabledInstruction = false;
      const Id = this.InstructionModel.Id == 0 ?
      this.InstructionForm.value.instruction_update ? this.InstructionForm.value.instruction_update
       : 'insert' :
       this.InstructionForm.value.instruction_update ? this.InstructionForm.value.instruction_update
       : 'update';
      this.sendClientID = [this.InstructionModel, this.InstructionForm, Id ,this.ClientId];

    }


  private savewithextension(buffer: any, fileName: string, format: string): void {

    if (format == 'xlsx') {
      const data: Blob = new Blob([buffer], { type: this.EXCEL_TYPE });
      FileSaver.saveAs(data, fileName);
    }
    else if (format == 'pdf') {
      const data: Blob = new Blob([buffer], { type: this.Pdf_type });
      FileSaver.saveAs(data, fileName);
    }
    else if(format == 'docx'){
      const data: Blob = new Blob([buffer], { type: this.word_type });
      FileSaver.saveAs(data, fileName);
    }
    else if(format == 'txt'){
      const data: Blob = new Blob([buffer], { type: this.Text_type });
      FileSaver.saveAs(data, fileName);
    }
    else if(format == 'png' || format == 'jpg'){
      const data: Blob = new Blob([buffer], { type: this.Image_type });
      FileSaver.saveAs(data, fileName);
    }
    else if(format == 'msg' || format == 'eml'){
      const data: Blob = new Blob([buffer], { type: this.Email_Type });
      FileSaver.saveAs(data, fileName);
    }
  }

  ManageInstruction(data){
    // if(this.getClientID.length)
    // this.fileAttachement.nativeElement = '';
    // console.log(this.fileAttachement.nativeElement, 'fileAttachement');
    // this.FileBase64Form = this.fileAttachement.nativeElement.value == '' ? '' : this.fileAttachement.nativeElement.value
    this.InstructionModel.File = this.FileBase64Form == undefined ? '' : this.FileBase64Form;
    this.InstructionModel.File_Name = this.InstructionModel.File_Name ? this.InstructionModel.File_Name : '';

    this.instructionservice.getSupervisorClientInstructionInformation(this.ClientId,data.Id).subscribe(res =>{
      this.InstructionModel.Instructions_Scenario = res.Data.Instructions_Scenario;
      this.InstructionModel.Instructions_Action = res.Data.Instructions_Action;
      this.InstructionForm.patchValue(res.Data);

      // this.ResponseHelper.GetSuccessResponse(res);
    }, err => {
      this.ResponseHelper.GetFaliureResponse(err);
    })
  }

}

export class InstructionModel {

  constructor() {
    this.Id = 0;
    this.Client_Id = "";
    this.Payer_Name = "";
    this.Practice_Name = "";
    this.Provider_Name = "";
    // this.Instructions = "";
    this.Type = "INACTIVE";
    this.Instructions_Scenario = "";
    this.Instructions_Action = "";
    this.Is_Active = false;
    this.Update_Category = "";
    this.Source = "";
    this.Communication_Channel = "";
    this.CPT_Code = "";
    this.Revenue_Code = "";
    this.Diagnosis_Code = "";
    this.Modifier = "";
    this.Place_of_Service = "";
    this.Received_From = "";
    this.File = "";
    this.File_Name = "";
  }
  Id: number;
  Client_Id;
  Type;
  Instructions_Scenario;
  Instructions_Action;
  Is_Active: boolean;
  Payer_Name;
  Practice_Name;
  Provider_Name;
  // Instructions;
  UpdatedDate;
  Source;
  Communication_Channel;
  Received_From;
  Update_Category;
  CPT_Code;
  Revenue_Code;
  Diagnosis_Code;
  Modifier;
  Place_of_Service;
  File_Name;
  File
}
